import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1,
  class: "file-icon-svg",
  viewBox: "0 0 32 32",
  fill: "none"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["fill"];
const _hoisted_5 = ["fill"];
const _hoisted_6 = {
  key: 1,
  stroke: "currentColor",
  "stroke-width": "1.5",
  fill: "none",
  "stroke-linecap": "round"
};
const _hoisted_7 = {
  key: 2,
  stroke: "currentColor",
  "stroke-width": "1.4",
  fill: "none",
  "stroke-linecap": "round"
};
const _hoisted_8 = {
  key: 3,
  stroke: "currentColor",
  "stroke-width": "1.4",
  fill: "none",
  "stroke-linecap": "round"
};
const _hoisted_9 = {
  key: 4,
  stroke: "currentColor",
  "stroke-width": "1.4",
  fill: "none",
  "stroke-linecap": "round"
};
const _hoisted_10 = {
  key: 5,
  stroke: "currentColor",
  "stroke-width": "1.4",
  fill: "none",
  "stroke-linecap": "round"
};
const _hoisted_11 = {
  key: 6,
  stroke: "currentColor",
  "stroke-width": "1.4",
  fill: "none",
  "stroke-linecap": "round"
};
import { computed } from 'vue';
import { getFileType, getExt, getFileUrl } from '@/utils/fileType';
export default {
  __name: 'FileIcon',
  props: {
    file: {
      type: [Object, String],
      default: null
    },
    // 外部指定文件名（优先于 file 对象）
    filename: {
      type: String,
      default: ''
    },
    // 是否对图片类型用缩略图
    thumb: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const TYPE_STYLE = {
      image: {
        bg: '#ecfeff',
        fg: '#0891b2',
        doc: '#ffffff',
        fold: '#cffafe',
        label: ''
      },
      pdf: {
        bg: '#fef2f2',
        fg: '#dc2626',
        doc: '#ffffff',
        fold: '#fee2e2',
        label: 'PDF'
      },
      docx: {
        bg: '#eff6ff',
        fg: '#2563eb',
        doc: '#ffffff',
        fold: '#dbeafe',
        label: 'DOC'
      },
      doc: {
        bg: '#eff6ff',
        fg: '#2563eb',
        doc: '#ffffff',
        fold: '#dbeafe',
        label: 'DOC'
      },
      xlsx: {
        bg: '#ecfdf5',
        fg: '#059669',
        doc: '#ffffff',
        fold: '#d1fae5',
        label: 'XLS'
      },
      xls: {
        bg: '#ecfdf5',
        fg: '#059669',
        doc: '#ffffff',
        fold: '#d1fae5',
        label: 'XLS'
      },
      pptx: {
        bg: '#fff7ed',
        fg: '#ea580c',
        doc: '#ffffff',
        fold: '#fed7aa',
        label: 'PPT'
      },
      ppt: {
        bg: '#fff7ed',
        fg: '#ea580c',
        doc: '#ffffff',
        fold: '#fed7aa',
        label: 'PPT'
      },
      archive: {
        bg: '#f5f3ff',
        fg: '#7c3aed',
        doc: '#ffffff',
        fold: '#ede9fe',
        label: 'ZIP'
      },
      video: {
        bg: '#fdf2f8',
        fg: '#db2777',
        doc: '#ffffff',
        fold: '#fce7f3',
        label: ''
      },
      audio: {
        bg: '#fdf4ff',
        fg: '#a21caf',
        doc: '#ffffff',
        fold: '#fae8ff',
        label: ''
      },
      text: {
        bg: '#f8fafc',
        fg: '#475569',
        doc: '#ffffff',
        fold: '#e2e8f0',
        label: ''
      },
      file: {
        bg: '#f1f5f9',
        fg: '#64748b',
        doc: '#ffffff',
        fold: '#e2e8f0',
        label: ''
      }
    };
    const type = computed(() => {
      if (props.file) return getFileType(props.file);
      if (props.filename) {
        const ext = getExt(props.filename);
        const map = {
          jpg: 'image',
          jpeg: 'image',
          png: 'image',
          gif: 'image',
          webp: 'image',
          bmp: 'image',
          svg: 'image',
          pdf: 'pdf',
          docx: 'docx',
          doc: 'doc',
          xlsx: 'xlsx',
          xls: 'xls',
          pptx: 'pptx',
          ppt: 'ppt',
          zip: 'archive',
          rar: 'archive',
          mp4: 'video',
          mp3: 'audio',
          txt: 'text'
        };
        return map[ext] || 'file';
      }
      return 'file';
    });
    const style = computed(() => TYPE_STYLE[type.value] || TYPE_STYLE.file);
    const bgColor = computed(() => style.value.bg);
    const fgColor = computed(() => style.value.fg);
    const docFill = computed(() => style.value.doc);
    const foldFill = computed(() => style.value.fold);
    const label = computed(() => style.value.label);
    const isImageThumb = computed(() => type.value === 'image' && props.thumb);
    const thumbUrl = computed(() => getFileUrl(props.file));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "file-icon-wrap",
        style: _normalizeStyle({
          background: bgColor.value,
          color: fgColor.value
        })
      }, [isImageThumb.value && thumbUrl.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: thumbUrl.value,
        class: "file-icon-thumb",
        alt: ""
      }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("svg", _hoisted_2, [_createElementVNode("path", {
        d: "M8 3h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
        fill: docFill.value
      }, null, 8, _hoisted_3), _createElementVNode("path", {
        d: "M20 3l6 6h-6V3z",
        fill: foldFill.value
      }, null, 8, _hoisted_4), label.value ? (_openBlock(), _createElementBlock("text", {
        key: 0,
        x: "16",
        y: "24",
        "text-anchor": "middle",
        "font-size": "8",
        "font-weight": "700",
        fill: fgColor.value,
        "font-family": "system-ui, sans-serif"
      }, _toDisplayString(label.value), 9, _hoisted_5)) : type.value === 'image' ? (_openBlock(), _createElementBlock("g", _hoisted_6, [...(_cache[0] || (_cache[0] = [_createElementVNode("rect", {
        x: "9",
        y: "11",
        width: "14",
        height: "10",
        rx: "1.5"
      }, null, -1), _createElementVNode("circle", {
        cx: "13",
        cy: "15",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }, null, -1), _createElementVNode("path", {
        d: "M11 20l3.5-3.5 2 2L20 15l3 3"
      }, null, -1)]))])) : type.value === 'text' ? (_openBlock(), _createElementBlock("g", _hoisted_7, [...(_cache[1] || (_cache[1] = [_createElementVNode("path", {
        d: "M10 12h12M10 16h12M10 20h8"
      }, null, -1)]))])) : type.value === 'archive' ? (_openBlock(), _createElementBlock("g", _hoisted_8, [...(_cache[2] || (_cache[2] = [_createElementVNode("rect", {
        x: "11",
        y: "10",
        width: "10",
        height: "14",
        rx: "1.5"
      }, null, -1), _createElementVNode("path", {
        d: "M16 10v3M16 14v2M16 17v2"
      }, null, -1)]))])) : type.value === 'video' ? (_openBlock(), _createElementBlock("g", _hoisted_9, [...(_cache[3] || (_cache[3] = [_createElementVNode("rect", {
        x: "9",
        y: "12",
        width: "14",
        height: "9",
        rx: "1.5"
      }, null, -1), _createElementVNode("path", {
        d: "M14 14.5l4 2.5-4 2.5z",
        fill: "currentColor",
        stroke: "none"
      }, null, -1)]))])) : type.value === 'audio' ? (_openBlock(), _createElementBlock("g", _hoisted_10, [...(_cache[4] || (_cache[4] = [_createElementVNode("path", {
        d: "M13 12v8M16 11v10M19 12v8M22 14v6"
      }, null, -1)]))])) : type.value === 'file' ? (_openBlock(), _createElementBlock("g", _hoisted_11, [...(_cache[5] || (_cache[5] = [_createElementVNode("path", {
        d: "M11 12h10M11 16h10M11 20h6"
      }, null, -1)]))])) : _createCommentVNode("", true)]))], 4);
    };
  }
};